export default __webpack_public_path__ + "dab590dcb24535e065202449609b3ef4.png";